import { render, staticRenderFns } from "./incomingv2.vue?vue&type=template&id=0891c52e&"
import script from "./incomingv2.vue?vue&type=script&lang=js&"
export * from "./incomingv2.vue?vue&type=script&lang=js&"
import style0 from "./incomingv2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports